<div class="flex flex-col-reverse sm:flex-col h-full">
  <app-nav></app-nav>

  <div sections class="flex flex-col flex-1">
    <mat-progress-bar *ngIf="isSearching" color="warn" mode="query"></mat-progress-bar>
    <section class="flex justify-center" search-bar-section>
      <form [formGroup]="searchForm" class="w-full pt-4 px-4 md:px-0 max-w-5xl flex flex-col md:flex-row md:gap-2.5">
        <mat-form-field class="flex-1">
          <mat-label>Search by names, location, or keywords</mat-label>
          <input formControlName="searchText" matInput placeholder="St. Mary's School" autocomplete="off"
            spellcheck="true" />
          <button type="button" *ngIf="searchForm?.get(['searchText'])?.value" matSuffix mat-icon-button
            aria-label="Clear search text" (click)="clearSearchInput()">
            <mat-icon>close</mat-icon>
          </button>

          <!-- 
            todo:
            1. change hint based on the tabs the user is currently on
            2. do dynamic placeholder text to show user what they can search
          -->
          <!-- <mat-hint></mat-hint> -->
        </mat-form-field>

        <div class="flex gap-2.5">
          <mat-form-field class="grow md:max-w-[212px]" appearance="fill">
            <mat-label>State</mat-label>
            <input type="text" placeholder="Delta" aria-label="State" matInput formControlName="state"
              [matAutocomplete]="autoState" />
            <button type="button" *ngIf="searchForm?.get(['state'])?.value" matSuffix mat-icon-button
              aria-label="Clear selected state" (click)="clearStateInput()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autoState="matAutocomplete">
              <mat-option value="All states">All states</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let option of filteredStates | async" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="searchForm?.get(['state'])?.hasError('required')">
              State is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="grow md:max-w-[212px]" appearance="fill">
            <mat-label>LGA</mat-label>
            <input type="text" placeholder="" aria-label="LGA" matInput formControlName="lga"
              [matAutocomplete]="autoLGA" (selectionchange)="lgaChanged($event)" />
            <button type="button" *ngIf="searchForm?.get(['lga'])?.value" matSuffix mat-icon-button
              aria-label="Clear selected LGA" (click)="clearLgaInput()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #autoLGA="matAutocomplete">
              <mat-option value="All LGAs">All LGAs</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let option of filteredLGAs | async" [value]="option">
                {{ option }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint *ngIf="!searchForm?.get(['state'])?.value">
              Select state for LGAs
            </mat-hint>
            <mat-error *ngIf="searchForm?.get(['lga'])?.hasError('required')">
              LGA is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Don't need button click. -->
        <!-- <button type="button" mat-icon-button color="secondary" aria-label="Search button">
                    <mat-icon>search</mat-icon>
                </button> -->
      </form>
    </section>

    <section search-result-section class="flex-1">
      <!-- loader is absolutely positioned, middle of search result section -->
      <div *ngIf="isFetchingResults; else searchResults" class="flex h-full justify-center items-center">
        <mat-spinner diameter="55" color="warn"></mat-spinner>
      </div>

      <ng-template #searchResults>
        <mat-tab-group preserveContent="true" [(selectedIndex)]="selectedTabIndex"
          class="downnnn h-full [&>.mat-mdc-tab-body-wrapper]:flex-1">
          <mat-tab aria-label="Items for sale" bodyClass="wow-testingg">
            <ng-template mat-tab-label>
              <span *ngIf="!callerService.isSmallScreen() || selectedTabIndex === SEARCH_TAB_INDEXES.SALES">Sales</span>
              <mat-icon class="ml-0.5" fontIcon="sell" aria-label="Sell icon" [matBadge]="results.sales.length"
                matBadgeOverlap="false"></mat-icon>
            </ng-template>

            <div results-list sales-results class="
              h-full w-full absolute overflow-y-scroll
              flex flex-wrap items-center gap-4 p-4 justify-center
              " *ngIf="results?.sales?.length; else noSalesResults">
              <app-feed-content *ngFor="let result of results?.sales" [post]="result">
              </app-feed-content>
            </div>
            <ng-template #noSalesResults>
              <p class="h-full flex items-center justify-center">{{getEmptyResultText}}</p>
            </ng-template>
          </mat-tab>

          <mat-tab aria-label="Accommodations for rent">
            <ng-template mat-tab-label>
              <!-- When we launch, update the selectedIndex check -->
              <span
                *ngIf="!callerService.isSmallScreen() || selectedTabIndex === SEARCH_TAB_INDEXES.ACCOMMODATIONS">Accommodation</span>
              <mat-icon class="ml-0.5" fontIcon="apartment" aria-label="apartment icon"
                [matBadge]="results.accommodations.length" matBadgeOverlap="false"></mat-icon>
            </ng-template>

            <div results-list accommodation-results class=" 
            h-full w-full absolute overflow-y-scroll
            flex flex-wrap items-center gap-4 p-4 justify-center
            " *ngIf="results?.accommodations?.length; else noAccommodationsResults">
              <app-feed-content *ngFor="let result of results?.accommodations" [post]="result">
              </app-feed-content>
            </div>
            <ng-template #noAccommodationsResults>
              <p class="h-full flex items-center justify-center">{{getEmptyResultText}}</p>
            </ng-template>
          </mat-tab>

          <mat-tab aria-label="Corp members">
            <ng-template mat-tab-label>
              <span *ngIf="!callerService.isSmallScreen() || selectedTabIndex === SEARCH_TAB_INDEXES.CORP_MEMBERS">Corp
                members</span>
              <mat-icon class="ml-0.5" fontIcon="groups" aria-label="corp members icon"
                [matBadge]="results.corp_members.length" matBadgeOverlap="false"></mat-icon>
            </ng-template>

            <div results-list corp-members-results class="
              h-full w-full absolute overflow-y-scroll
              flex flex-wrap items-center gap-4 p-4 justify-center
              " *ngIf="results?.corp_members?.length; else noCorpMembersResults">
              <mat-card *ngFor="let corp_member of results?.corp_members" class="w-[300px]">
                <mat-card-header>
                  <img mat-card-avatar
                    title="Profile picture of {{ corp_member?.nickname || corp_member?.first_name || 'Corp member' }}"
                    [src]="corp_member?.Media?.url || 'https://placehold.co/50x50/4ade80/000/?text=' + (corp_member?.nickname ?? corp_member?.first_name ?? 'C.')" />
                  <mat-card-title>{{
                    corp_member?.nickname || corp_member?.first_name || '-'
                  }}</mat-card-title>
                  <mat-card-subtitle>Joined {{ corp_member?._age }}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <p>
                    {{ corp_member.bio ?? 'No bio.' }}
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
            <ng-template #noCorpMembersResults>
              <p class="h-full flex items-center justify-center">{{getEmptyResultText}}</p>
            </ng-template>
          </mat-tab>

          <mat-tab aria-label="PPAs">
            <ng-template mat-tab-label>
              <span *ngIf="!callerService.isSmallScreen() || selectedTabIndex === SEARCH_TAB_INDEXES.PPAs">PPAs</span>
              <mat-icon class="ml-0.5" fontIcon="home_work" aria-label="PPAs icon" [matBadge]="results.ppas.length"
                matBadgeOverlap="false"></mat-icon>
            </ng-template>

            <div results-list ppas-results class="
              h-full w-full absolute overflow-y-scroll
              flex flex-wrap items-center gap-4 p-4 justify-center
              " *ngIf="results?.ppas?.length; else noPPAResults">
              <mat-card *ngFor="let ppa of results?.ppas" class="w-[300px]">
                <mat-card-header class="mb-2">
                  <mat-card-title>
                    {{ ppa.name }}
                  </mat-card-title>
                  <mat-card-subtitle>
                    {{ ppa.type_of_ppa }}
                    <span *ngIf="ppa.Locations?.length">
                      &middot;
                      {{ ppa.Locations?.[0]?.State?.name }},
                      {{ ppa.Locations?.[0]?.StateLGA?.name }}
                    </span>
                  </mat-card-subtitle>
                  <mat-card-subtitle *ngIf="ppa.Locations?.length">
                    {{ppa.Locations?.[0]?.address}}
                  </mat-card-subtitle>
                </mat-card-header>

                <mat-card-content *ngIf="ppa.Locations?.length > 1">

                  <!-- @todo: add functionality to view other locations -->
                  <button type="button" mat-button> View {{ ppa.Locations?.length - 1 }} more location{{
                    ppa.Locations?.length > 2 ? 's' : ''
                  }}</button>

                </mat-card-content>

                <mat-divider></mat-divider>
                <mat-card-actions align="end">
                  <button *ngIf="ppa.Reviews?.length" (click)="openMorePpaDetails(ppa)" type="button" mat-button
                    color="primary">
                    See <span>{{ ppa.Reviews?.length | shortenNumber }} review{{
                      ppa.Reviews?.length > 1 ? 's' : ''
                    }}</span>
                  </button>
                  <button type="button" mat-button (click)="leaveReview(ppa)">
                    Leave review
                  </button>
                </mat-card-actions>
              </mat-card>
            </div>
            <ng-template #noPPAResults>
              <p class="h-full flex items-center justify-center">{{getEmptyResultText}}</p>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </section>
  </div>
</div>